import { api } from '../../api'
import type { PlatformDashboardDTO, PlatformMetricsDTO } from '@/types/admin'

/**
 * Get complete platform dashboard data
 */
export async function getAdminDashboard(): Promise<PlatformDashboardDTO> {
  const response = await api.get<PlatformDashboardDTO>('/api/admin/dashboard')
  return response.data
}

/**
 * Get platform metrics only (for quick refresh)
 */
export async function getPlatformMetrics(): Promise<PlatformMetricsDTO> {
  const response = await api.get<PlatformMetricsDTO>('/api/admin/dashboard/metrics')
  return response.data
}
